import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import Logo from '../../components/Logo';
import Background from '../../components/Background';

import './style.scss';

class Fallback extends React.Component {
  state = {
    isBooked: false,
  };

  componentWillMount() {
    const { isAuthenticated } = this.props;
    if (!isAuthenticated) {
      this.props.router.push({
        pathname: '/assessment',
      });
      return;
    }

    const { location: { state } } = this.props;
    this.setState({
      ...state,
    });
  }

  getBack() {
    return (
      <div className="fallback__back">
        <div>
          <a href="https://www.paragonone.com">Back to Homepage</a>
        </div>
      </div>
    );
  }

  render() {
    // TODO: add personalized message + testimonials
    return (
      <div>
        <Background blue />
        <Logo white />
        <div className="assessment__wrapper--narrow">
          <div className="confirmation__heading">
            Unfortunately we were unable to find any advisors based on your
            interests.
          </div>
          <div className="confirmation__subheading">
            <div>
              Please contact{' '}
              <a
                className="fallback__link"
                href="mailto:advisor@paragonone.com"
              >
                advisor@paragonone.com
              </a>{' '}
              if you have any questions.
            </div>
            <br />
            <div>
              In the meantime, join our community in Slack, the online messaging
              platform.{' '}
              <a
                className="confirmation__link"
                href="https://www.google.com/url?q=https://join.slack.com/t/paragonone-community/shared_invite/enQtMzIzODI4MjU0OTgyLWE3ZDM1NjE3Mzk1MTllNDViNGRlMDkxMzI5OTEyZmVhZjM3NzdmYjI1MzBhMzNkZWY5OTc1Y2UwZWFiNzVkNmM&sa=D&ust=1521231645488000&usg=AFQjCNHXD8pqxJ5GuRrDd23vmHQ4nxFWPg"
                target="_blank"
              >
                Click here to sign up now!
              </a>
            </div>
          </div>
          {this.getBack()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authedUser: _.get(state, 'auth.User'),
  isAuthenticated: !!_.get(state, 'auth.sub'),
});

const mapDispatchToProps = {};

export default store => ({
  path: 'fallback',
  component: connect(mapStateToProps, mapDispatchToProps)(Fallback),
});



// WEBPACK FOOTER //
// ./src/routes/assessment/routes/Fallback/index.js